import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppointmentService } from '../../../shared/services/appointment.service';
import { IDashboardVehicle, IServiceHistory } from '../../../shared/models/dashboard.model';
import { ServiceHistory } from '../../../shared/models/service-history.model';
import { BdcDashboardState } from '../../../store/bdcdashboard/bdcdashboard.reducer';
import { Store } from '@ngrx/store';
import { IVehicle } from '@signal/asp-data-commons';
import { Observable } from 'rxjs';
import { selectUserVehiclesBasedOnVin } from '../../../store/bdcdashboard/bdcdashboard.selectors';
import { ViewportScroller } from '@angular/common';
import { DealerState } from 'src/app/modules/store/dealer/dealer.reducer';
import { AspBannerService } from '../../../shared/services/asp-banner.service';
import { TranslateService } from '@ngx-translate/core';
import * as util from '../../../shared/services/util.service';
import { SubscriptionList } from 'src/app/modules/shared/models/asp.types';

@Component({
  selector: 'app-service-history',
  templateUrl: './service-history.component.html',
  styleUrls: ['./service-history.component.scss']
})
export class ServiceHistoryComponent implements OnInit, OnDestroy {
  vin: string;
  serviceHistory: IServiceHistory[];
  userVehicleDetails$: Observable<IDashboardVehicle[]>;
  vehicleDetails: IVehicle;
  sub: SubscriptionList = {};
  loading = false;
  errorMessage = false;
  mileageUnit: string;
  selectedVin: string = '';
  allServiceHistory = [];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly userVehicleService: AppointmentService,
    private readonly dashboardState: Store<BdcDashboardState>,
    private readonly viewportScroller: ViewportScroller,
    private readonly dealerState: Store<DealerState>,
    private readonly router: Router,
    private bannerService: AspBannerService,
    private readonly translate: TranslateService
  ) {
    this.mileageUnit = this.translate.instant(`recommendedService.${this.translate.instant('COUNTRYTRANSLATION.miles')}`);
  }

  ngOnInit(): void {
    this.initializeComponent();
    this.selectedVin = this.vin;
  }

  fetchServiceHistory() {
    this.sub.servicehistory?.unsubscribe();
    this.sub.servicehistory = this.userVehicleService.getVehicleServiceHistory(this.vin).subscribe(data => {
      if (data.status.code === 200) {
        const records = data.data.payload.vehicleServiceHistory;
        this.serviceHistory = ServiceHistory.getSerivceHistoryArray(records);
        this.allServiceHistory.push({ vin: this.vin, data: this.serviceHistory });
        this.loading = false;
        this.errorMessage = false;
      }
    },
      error => {
        const serviceHistory = [] as IServiceHistory[];
        this.allServiceHistory.push({ vin: this.vin, data: serviceHistory })
        this.loading = false;
        this.errorMessage = true;
      }
    );

  }

  onVehicleSelect(value) {
    this.router.navigate(['./../servicehistory'], {
      relativeTo: this.route,
      queryParams: {
        vin: value
      }
    }).then(() => {
      this.initializeComponent();
    });

  }

  backToDashboard() {
    this.router.navigate(['../'], { relativeTo: this.route, queryParams: { vin: this.selectedVin, selectedVehicle: true } });
  }

  ngOnDestroy(): void {
    this.allServiceHistory = [];
    util.unsubscribeSubscriptions(this.sub);
    this.bannerService.update('');
  }

  initializeComponent() {
    this.viewportScroller.scrollToPosition([0, 0]);
    this.bannerService.update('');
    this.sub.query = this.route.queryParams.subscribe(params => {
      this.vin = params.vin;
      this.loading = true;
      this.errorMessage = true;
      const serviceHistoryForSelectedVin = this.allServiceHistory.find(value => value.vin === this.vin)
      if (!serviceHistoryForSelectedVin) {
        this.fetchServiceHistory();
      }
      else {
        this.loading = false;
        this.errorMessage = serviceHistoryForSelectedVin.data.length ? false : true;
        this.serviceHistory = serviceHistoryForSelectedVin.data;
      }
    });

    this.userVehicleDetails$ = this.dashboardState.select(selectUserVehiclesBasedOnVin);
    this.sub.vehicledetails = this.userVehicleDetails$.subscribe(data => {
      if (data) {
        this.vehicleDetails = data.find(x => x.vin === this.vin);
        this.bannerService.update(this.vehicleDetails?.imageUrl);
      }
    }, error => {
    });
  }


}
